__turbopack_context__.v({
  "container": "CkF62q_container",
  "headingText": "CkF62q_headingText",
  "productGrid": "CkF62q_productGrid",
  "skeletonCard": "CkF62q_skeletonCard",
});
